module.exports = __webpack_public_path__ + "img/mooh.98592aba.jpeg";